import { useMemo } from 'react';
import { useCsrfToken } from './useCsrfToken';

export function useJsonHeaders() {
  const csrfToken = useCsrfToken();
  const headers = useMemo(
    () => ({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'YII-CSRF-TOKEN': csrfToken,
    }),
    [csrfToken]
  );
  return headers;
}
